<div class="premium-dialog-header">
  <div class="dialog-badge-icon dialog-badge-indigo">
    <mat-icon>download</mat-icon>
  </div>
  <h2>{{ 'downloadOrderFiles.title' | translate }}</h2>
</div>
<div mat-dialog-content class="min-w-96">
  @if (error) {
    <div class="dialog-error">
      <p>{{ error | error }}</p>
    </div>
  }
  <div class="flex flex-col gap-4 items-start">
    @if (canDownloadFilesAndProofs) {
      <mat-checkbox [formControl]="customerFiles" [disabled]="progress">
        {{ 'ADMIN.SHOW_FILES_VIEW' | translate }}
      </mat-checkbox>
      <mat-checkbox [formControl]="proofFiles" [disabled]="progress">
        {{ 'ADMIN.SHOW_BAT_VIEW' | translate }}
      </mat-checkbox>
      <mat-slide-toggle [formControl]="originalName" [disabled]="progress">
        {{ 'keepOriginalName' | translate }}
      </mat-slide-toggle>
    }
    @if (canDownloadProd) {
      <mat-divider class="w-full"></mat-divider>
    }
    @if (authService.hasRole([RolesEnum.ORDER_WRITE, RolesEnum.SALES]) && this.isOwner()) {
      <mat-checkbox
        [formControl]="prepressFiles" [disabled]="progress">
        {{ 'ADMIN.SHOW_PAO_VIEW' | translate }}
      </mat-checkbox>
    }
    @if (canDownloadProd) {
      <mat-checkbox
        [formControl]="productionFiles" [disabled]="progress">
        {{ 'ADMIN.SHOW_PROD_VIEW' | translate }}
      </mat-checkbox>
    }
  </div>
</div>
@if (progress;) {
  <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
}
<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()" class="action-button" [disabled]="progress">
    {{ 'common.close' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="download()" class="action-button"
    [disabled]="progress || noneSelected">
    <mat-icon>download</mat-icon>
    {{ 'download' | translate }}
  </button>
</div>
